/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgUploadSheet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    viewBox="0 0 60 61"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.844 15.553v29.894h29.894V15.553H3.844ZM25.33 37.97h-5.607l-1.664-3.323-2.075 3.323h-3.738l4.154-6.645-4.154-8.303h5.607l1.659 3.323 2.074-3.323h3.738l-4.154 6.645 4.16 8.303ZM56.156 8.082v48.574H11.315v-9.34h3.738v5.608h37.365V8.082H15.053v5.602h-3.739v-9.34h44.842v3.738Zm-20.549 18.68h13.078V30.5H35.608v-3.738Zm0-7.471h13.078v3.738H35.608v-3.738Zm0 14.947h13.078v3.739H35.608v-3.739Z"
    />
  </svg>
)
const Memo = memo(SvgUploadSheet)
export default Memo
